import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.href && _vm.phone
    ? _c(
        "div",
        {
          staticClass:
            "price-phone-bar bg-gray-0 pa-3 rounded-t-20 elevation-1",
          attrs: { "data-qa": "lpu_page_price_phone_bar" },
        },
        [
          _c(
            VBtn,
            {
              staticClass:
                "branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1",
              attrs: {
                href: _vm.href,
                depressed: "",
                block: "",
                height: "52",
                "data-qa": "lpu_page_price_phone_bar_button",
              },
            },
            [
              _c("span", {
                staticClass:
                  "ui-icon-ui-call ui-icon-fz-big bg-gray-0--text mr-2",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v("\n    " + _vm._s(_vm.phone) + "\n  "),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }